import { NavigationContainer } from '@react-navigation/native';
import AuthStack from './authStack';
import AppStack from './appStack';
import Loading from '../components/loading';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { setUser, setUserLoading, setLoginLoading } from '../redux/userSlice';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../Firebase/firebase';
import { User } from '../types';
import Snackbar from '../components/snackbar';
import { setSnackbar } from '../redux/snackbarSlice';
import { View } from 'react-native';

export default function Routes() {
  const { user, userLoading } = useAppSelector((state) => state.user);
  const auth = getAuth();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const subscriber = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        const userDocRef = doc(db, 'users', authUser.uid);
        const data = await getDoc(userDocRef);
        const fetchedUser = { ...data.data(), id: authUser.uid } as User;
        dispatch(setUser(fetchedUser));
      } else {
        dispatch(setUser(null));
      }
      dispatch(setLoginLoading(false));
      dispatch(setUserLoading(false));
    });
    return subscriber; // unsubscribe on unmount
  }, []);

  if (userLoading) {
    return <Loading />;
  }

  return (
    <>
      <NavigationContainer>
        {user ? <AppStack /> : <AuthStack />}
      </NavigationContainer>
      <View style={{ width: '100%' }}>
        <Snackbar />
      </View>
    </>
  );
}
